module.exports = __webpack_public_path__ + "static/horbury-ossett-app-image-43627982157d58c2a28c3511815b2bf9.png";